import styled from 'styled-components';
import { mediaquery, unitizedPx } from '@badi/badi-components';

export const FormWrapper = styled.div`
  max-width: auto;

  ${mediaquery.lg`
    max-width: ${unitizedPx(47)};
  `}
`;

export const PopoverWrapper = styled.div`
  position: absolute;
  z-index: 2;
  display: block;
  max-width: ${unitizedPx(47)};
  margin-top: -14px;
`;

export const CalendarLegendWrapper = styled.div`
  padding: 1em 1.5em 0 1.5em;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
`;

export const LegendMarker = styled.span`
  width: 12px;
  height: 12px;
  background: #0ad2dc;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
`;

export const OutOfFortnightDay = styled.span`
  min-width: 1.6em;
  border-radius: 50%;
  display: inline-block;
`;

export const NormalDay = styled.span``;

export const MoveInToday = styled.div`
  background-color: #ffd685;
  padding: 16px;
  border-radius: 16px;
`;
